import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import {
  IconArchive,
  IconFlag,
  IconZoomCheck,
} from '@tabler/icons-react';
import moment from 'moment-timezone';

/** Número, data e ticker em mono tabular, no tamanho do texto ao redor. */
const dadoInline = {
  fontSize: 'inherit',
  fontWeight: 500,
  color: 'text.primary',
} as const;

interface AlertaVendaSemCompraProps {
  codigoAtivo: string;
  quantidade: number;
  dataPregao: string;
}

export default function AlertaVendaSemCompra({
  codigoAtivo,
  quantidade,
  dataPregao,
}: AlertaVendaSemCompraProps) {
  const dataFormatada = moment(dataPregao).format('DD/MM/YYYY');
  const dataRef = moment(dataPregao).subtract(1, 'day').format('YYYYMMDD');

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        Foi identificada uma venda de{' '}
        <Typography component="span" variant="dataMono" sx={dadoInline}>
          {quantidade} {codigoAtivo}
        </Typography>{' '}
        em{' '}
        <Typography component="span" variant="dataMono" sx={dadoInline}>
          {dataFormatada}
        </Typography>{' '}
        sem a compra correspondente cadastrada.
      </Typography>

      <Typography variant="body2" sx={{ fontWeight: 600, mb: 1.5 }}>
        Esqueceu de lançar essa compra?
      </Typography>

      <Box display="flex" gap={1} flexWrap="wrap" alignItems="center">
        <Button
          variant="contained"
          color="primary"
          size="small"
          component={Link}
          to="/arquivo#uploads"
          startIcon={<IconArchive />}
        >
          Sim, cadastrar agora
        </Button>
        <Button
          variant="outlined"
          color="inherit"
          size="small"
          component={Link}
          to={`/checkpoint#${dataRef}`}
          startIcon={<IconFlag />}
        >
          Não lembro, conferir na B3
        </Button>
        <Button
          variant="text"
          color="inherit"
          size="small"
          component={Link}
          to={`/consulta#${codigoAtivo}`}
          startIcon={<IconZoomCheck />}
        >
          Investigar no histórico de {codigoAtivo}
        </Button>
      </Box>
    </Box>
  );
}
